import {
  TABLE_CELL_BORDER_RIGHT_WIDTH,
  TABLE_CELL_PADDING_X,
} from 'components/Table/tableSettings';

const getCellContentElements = (
  tableContainer: HTMLElement,
  columnKey: string,
): HTMLElement[] =>
  Array.from(
    tableContainer.querySelectorAll(
      `[data-column="${CSS.escape(columnKey)}"] .ipf-table__cell-content`,
    ),
  );

const getCellWidthThatFitsContent = (cell: HTMLElement) => {
  const contentWidth = cell.classList.contains(
    'ipf-table__severity-badge--empty',
  )
    ? 0 // empty severity badge is rendered at whole cell but actually contains nothing, so consider 0 content.
    : cell.clientWidth;
  return (
    contentWidth + 2 * TABLE_CELL_PADDING_X + TABLE_CELL_BORDER_RIGHT_WIDTH
  );
};

export const getColumnWidthThatFitsContent =
  (tableContainer: HTMLElement) =>
  (columnKey: string): number =>
    Math.max(
      ...getCellContentElements(tableContainer, columnKey).map(
        getCellWidthThatFitsContent,
      ),
    );
